// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--3an40","body":"body--2cBtX"};